import { gql, TypedDocumentNode } from '@common/hooks';
import {
  ServiceLineSchedulingPeriodQueryCgResponse,
  ServiceLineSchedulingPeriodQueryVariables,
} from '@common/graphql';

// Work-period dates of the scheduling period for the Service Line Team Review page. The
// page anchors each worker's "current" contract term on `periodStart` (the contract in
// effect when the period begins); a null result (no / stale / out-of-org period) lets the
// page fall back to today.
export const SERVICE_LINE_SCHEDULING_PERIOD_QUERY: TypedDocumentNode<
  ServiceLineSchedulingPeriodQueryCgResponse,
  ServiceLineSchedulingPeriodQueryVariables
> = gql`
  query ServiceLineSchedulingPeriod(
    $serviceLineId: ID!
    $schedulingPeriodId: ID!
  ) {
    serviceLineSchedulingPeriod(
      serviceLineId: $serviceLineId
      schedulingPeriodId: $schedulingPeriodId
    ) {
      id
      periodStart
      periodEnd
    }
  }
`;
